<div class="balance-history">
  <a class="button-close" (click)="closeDialog()">
    <i class="material-icons fill-nightfall">close</i>
  </a>
  <form [formGroup]="searchForm">
    <div class="d-md-block d-none">
      <div class="balance-search-form row">
        <div class="text-sm">
          <strong>Balance History ({{currencyName}}) | </strong> Select Date Range
        </div>

        <span class="mr-3 ml-auto">From</span>
        <div class="date-field">
          <mat-form-field>
            <input matInput [matDatepicker]="fromDate" placeholder="dd/mm/yyyy" formControlName="fromDate" />
            <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
            <mat-datepicker panelClass="greengo" #fromDate></mat-datepicker>
          </mat-form-field>
        </div>
        <span class="mx-3">To</span>
        <div class="date-field mr-3">
          <mat-form-field>
            <input matInput [matDatepicker]="toDate" placeholder="dd/mm/yyyy" formControlName="toDate" />
            <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker panelClass="greengo" #toDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="button-search">
          <button type="button" class="btn btn-lg btn-greengo" (click)="getSearchData()" npFocusOutClicked>Search</button>
        </div>
      </div>
    </div>


    <div class="balance-search-form d-block d-md-none">
      <div class="row form-group">
        <div class="text-sm">
          <strong>Balance history | </strong> select date range
        </div>
      </div>

      <div class="row form-group">
        <div class="col-6 pl-0">
          <mat-form-field>
            <input matInput [matDatepicker]="fromDateMobile" placeholder="From date" formControlName="fromDate" />
            <mat-datepicker-toggle matSuffix [for]="fromDateMobile"></mat-datepicker-toggle>
            <mat-datepicker panelClass="greengo" #fromDateMobile></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-6 pr-0">
          <mat-form-field>
            <input matInput [matDatepicker]="toDateMobile" placeholder="To date" formControlName="toDate" />
            <mat-datepicker-toggle matSuffix [for]="toDateMobile"></mat-datepicker-toggle>
            <mat-datepicker panelClass="greengo" #toDateMobile></mat-datepicker>
          </mat-form-field>
        </div>
      </div>


      <div class="row form-group">
        <div class="col-6 ml-auto pr-0">
          <button type="button" class="btn btn-block btn-lg btn-greengo" (click)="getSearchData()" npFocusOutClicked>Search</button>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="text-sm">
        <strong>Current Balance:</strong> {{ currentBalance | transformNumber }}
      </div>
    </div>

    <div *ngIf="hasData" class="row form-group">
      <div class="text-sm">
        <strong>Opening Balance:</strong> {{ openingBalance | transformNumber }}
      </div>
    </div>

    <div class="balance-history-table">
      <ng-table
        [rows]="rows"
        [columns]="columns">
      </ng-table>
    </div>

    <div *ngIf="hasData" class="row form-group" >
      <div class="text-sm">
        <strong>Closing Balance:</strong> {{ closingBalance | transformNumber }}
      </div>
    </div>
  </form>
</div>
